import React, { useState } from 'react'
import DataTableExtensions from 'react-data-table-component-extensions';
import DataTable from 'react-data-table-component';
import { Badge } from 'react-bootstrap';

const customStyles = {
    rows: {
      style: {
        minHeight: '72px', // override the row height
      }
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
};

const mock = [
    {
        id: 1,
        client_name: 'Aguilas Express SPA',
        country: 'CL',
        state: 1,
    },
    {
        id: 2,
        client_name: 'Alas del Timon Cargo SPA',
        country: 'CL',
        state: 1,
    },
    {
        id: 3,
        client_name: 'B&R Cargo SPA',
        country: 'CL',
        state: 1,
    },
    {
        id: 4,
        client_name: 'Americargo SPA',
        country: 'CL',
        state: 1,
    }
]

export default function ClientTable() {

  const [data, setData] = useState(mock);

  const columns = [
      {
        name: 'CLIENTE',
        selector: 'client_name',
        sortable: true,
      },
      {
        name: 'PAIS',
        selector: 'country',
        sortable: true,
      },
      {
        name: 'ESTADO',
        selector: 'state',
        sortable: true,
        cell: row => {
            switch(row.state){
                case 1:
                    return 'Activo';
                case 2:
                    return 'Inactivo';
                default:
                    return 'N/I';
            }
        }
      },
  ]

  return (
    <DataTableExtensions
        columns={columns}
        data={data}
        export={false}
        print={false}
        filterPlaceholder="Buscar cliente"
    >
      <DataTable
        noHeader
        customStyles={customStyles}
        dense={true}
        pagination={true}
        paginationPerPage={50}
        noDataComponent={"No existen datos cargados."}
        style={{ 
          minHeight: 400,
        }}
    />
  </DataTableExtensions>
  )
}
